import { ColumnType } from "antd/es/table";
import React, { useEffect, useState } from "react";
import { Table, message } from "antd";
import reportApis from "../../../api/reports";
import dayjs from "dayjs";
import { useWbsName } from "../../ProjectScheduleManagement/shared/useWbsCodes";

interface ToolsAndMachineryReportProps {
  selectedDate: any;
  projectId: number;
}

const ToolsAndMachineryReport: React.FC<ToolsAndMachineryReportProps> = ({
  selectedDate,
  projectId,
}) => {
  const wbsName = useWbsName();
  const [dataSource, setDataSource] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 0,
  });

  const columns: ColumnType<any>[] = [
    {
      title: "Activity",
      dataIndex: "activityName",
      key: "activityName",
      render: (text: any) => wbsName(text),
    },
    { title: "Task", dataIndex: "taskName", key: "taskName" },
    { title: "Type", dataIndex: "toolType", key: "toolType" },
    { title: "Name", dataIndex: "toolName", key: "toolName" },
    { title: "Planned", dataIndex: "planned", key: "planned" },
    { title: "At Site", dataIndex: "atSite", key: "atSite" },
  ];

  const fetchData = async (params: any) => {
    setLoading(true);
    try {
      const { current, pageSize, direction, pageDiff, paginationId } = params;

      const apiResponse = await reportApis.fetchPMSReports({
        projectIds: projectId,
        page: current,
        pageSize: pageSize,
        reportName: "toolsAndMachinaryDailyProgress",
        endDate: selectedDate && dayjs(selectedDate).format("YYYY-MM-DD"),
      });

      const { data, status } = apiResponse || {};
      if (status) {
        const { list, count } = data;
        setPagination((prev) => ({
          ...prev,
          total: Number(count),
        }));
        if (list) setDataSource(list);
      }
    } catch (error) {
      console.error("Error loading tools and machinery data:", error);
      message.error("Failed to load tools and machinery data");
    } finally {
      setLoading(false);
    }
  };

  const tableOnChange = async (
    newPagination: any,
    filters: any,
    sorter: any
  ) => {
    const apiParams = {
      current: newPagination.current?.toString(),
      pageSize: pagination.pageSize,
      direction: "P",
      pageDiff: 0,
      paginationId: null,
    };

    if (newPagination.current !== pagination.current) {
      apiParams.direction =
        newPagination.current > pagination.current ? "F" : "B";
      apiParams.paginationId =
        apiParams.direction === "F"
          ? dataSource[dataSource.length - 1]?.paginationId
          : dataSource[0]?.paginationId;
      apiParams.pageDiff =
        Math.abs(newPagination.current - pagination.current) - 1;
    }

    setPagination({
      ...pagination,
      current: apiParams.current,
    });

    await fetchData(apiParams);
  };

  useEffect(() => {
    if (selectedDate) {
      fetchData({
        current: 1,
        pageSize: pagination.pageSize,
        direction: "P",
        pageDiff: 0,
        paginationId: null,
      });
    }
  }, [selectedDate]);

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      pagination={pagination}
      onChange={tableOnChange}
      loading={loading}
      size="small"
      bordered
    />
  );
};

export default ToolsAndMachineryReport;
